<template>
  <div>
    <EditableCoOwnersListDialog
      :changeSelectedPeopleInfo="changeSelectedPeopleInfo"
      :peopleSearchDialog="peopleSearchDialog"
      :toggleModal="toggleModal"
      :selectedPeopleList="owners"
      v-on:personAdded="($event) => this.$emit('personAdded', { personId: $event.personId })"
      :searchCoownersFn="searchCoownersFn"
      />
    <v-row>
      <v-col>             
        <v-alert type="info">
          The paw icon indicates the primary {{ title(ownershipType) }}.<br/>
          Select another person as primary {{ title(ownershipType) }} by clicking their name.
        </v-alert>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="8">
        <div v-if="!!owners && owners.length">
          <v-radio-group v-model="primary" @change="changePrimary">
            <span v-for="co in owners" :key="co.personId">
              <span>
                <v-layout align-start row class="mb-3">
                  <v-radio color="primary" :value="co.personId">
                    <template v-slot:label
                      ><span v-if="co.isPrimary">
                        <v-tooltip dark right>
                          <template v-slot:activator="{on, attrs }">
                            <font-awesome-icon
                              icon="paw"
                              color="primary"
                              v-bind="attrs"
                              v-on="on"
                            />&nbsp;
                          </template>
                          <span>
                            &nbsp;{{tooltipText(ownershipType)}}
                          </span>
                        </v-tooltip>
                      </span>
                      <span v-else>
                        <font-awesome-icon icon="paw" color="transparent" />&nbsp;
                      </span>
                    <span>
                      <b>
                        {{ co.firstName }} {{ co.lastName }}
                        <span v-if="co.memberId">&nbsp;
                          (<font-awesome-icon icon="id-card" :color="co.isActiveMember == false ? 'red' : 'green'" />
                            {{co.isActiveMember == false ? ' Expired' : ' Active'}} Member ID#: {{ co.memberId }})</span>
                      </b>
                    </span> 
                    </template>
                  </v-radio>
                </v-layout>
              </span>
            </span>
          </v-radio-group>
        </div>
      </v-col>
      <v-col>        
        <v-btn v-if="!!owners && owners.length" v-on:click="toggleModal()" class="primary"> 
          Add or Remove {{ title(ownershipType) }}(s)
        </v-btn>
        <v-btn v-else v-on:click="toggleModal()"  class="primary">
            <font-awesome-icon icon="plus" />
          Add {{ title(ownershipType) }}
        </v-btn>
      </v-col>
    </v-row>
  </div>
</template>

<script lang="ts">
import Vue from "vue";
import EditableCoOwnersListDialog from "./EditableCoOwnersListDialog.vue";

export enum OwnershipType {
  Dog = 1,
  Lease = 2,
  Litter = 3,
  Kennel = 4,
}

export default Vue.extend({
  name: "EditableCoOwnersList",
  data: function () {
    return {
      peopleSearchDialog: false,
    };
  },
  components: {
    EditableCoOwnersListDialog,
  },
  computed: {
    primary: function () {
      const idx = this.owners.findIndex((object: any) => {
        return object.isPrimary;
      });
      if (idx >= 0) {
        return (this as any).owners[idx].personId;
      }
      return 0
    },
  },
  methods: {
    changePrimary(personId: number) {
      const index = this.owners.map((c: any) => c.personId).indexOf(personId);
      this.owners.forEach((co: any) => (co.isPrimary = false));
      (this as any).owners[index].isPrimary = true;
      this.$emit("selectedOwnersChanged", { newPeople: this.owners });
    },
    changeSelectedPeopleInfo: function (newPeople: any) {
      this.$emit("selectedOwnersChanged", { newPeople: newPeople });
    },
    toggleModal: function () {
      this.$data.peopleSearchDialog = !this.$data.peopleSearchDialog;
    },
    title(ownershipType: OwnershipType) {
      if (ownershipType == OwnershipType.Lease) {
        return "Lessee";
      } else if(ownershipType == OwnershipType.Litter) {
        return "Litter owner";         
      } else if(ownershipType == OwnershipType.Dog) {
        return "Dog owner"; 
      } else {
        return "Owner";
      }
    },
    tooltipText(ownershipType: OwnershipType) {
      if (ownershipType == OwnershipType.Lease) {
        return "Only the primary lessee can register litters, release and register puppies. They will also be a primary contact person for the ASCA office.";
      }
      if (ownershipType == OwnershipType.Dog) {
        return "Only the primary owner can register litters, and lease the dog. They will also be a primary contact person for the ASCA office.";
      }
      if (ownershipType == OwnershipType.Kennel) {
        return "Only the primary owner can request kennel ownership changes. They will also be a primary contact person for the ASCA office.";
      }
      if (ownershipType == OwnershipType.Litter) {
        return "Only the primary owner can register and release puppies from the litter. They will also be a primary contact person for the ASCA office.";
      }
      return "";
    },
  },
  props: {
    ownershipType: Number,
    owners: Array,
    searchCoownersFn: Function,
  },
});
</script>
